export default __webpack_public_path__ + "static/media/04china04.5ae3f29f.png";